import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;


export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Función de Auditoría corregida
// En src/supabaseClient.js
// src/supabaseClient.js
export const registrarActividad = async (email, accion, detalles = {}) => {
    const { error } = await supabase
        .from('logs')
        .insert([{
            admin_email: email, //
            usuario: email.split('@')[0],
            accion: accion,
            detalles: detalles,
            fecha: new Date().toISOString()
        }]);

    if (error) console.error("Error al registrar log:", error.message);
};